import { BACKGROUND_COLOR_DEFAULT, TEXT_COLOR_DEFAULT } from '../constants/colors';
import { FONT_DEFAULT_VALUE } from '../constants/fonts';
import type { Clip } from '../types/clip-types';
import { rgbaToHex } from './colorUtils';
import { migrateSpeakerLabelStyles } from './speakerLabelUtils';

export const applyDefaultStylesToRS = (clip: Clip) => {
  const theme_obj = clip.content?.project?.theme_obj || {};
  const {
    fit,
    border,
    layout,
    stage_background_type,
    stage_background,
    primary_text_color,
    name_card_text_color,
    name_card_background,
    name_card_visibility_toggle,
    name_card_font_url,
    name_card_border_radius
  } = theme_obj;

  // By default we show speaker labels in recording studio
  const showSpeakerLabels = name_card_visibility_toggle === undefined || name_card_visibility_toggle === 'visible';
  const backgroundImage =
    stage_background_type === 'Image' ? stage_background.replace('url(', '').replace(')', '') : undefined;
  const backgroundColor = stage_background_type === 'Color' ? rgbaToHex(stage_background) : BACKGROUND_COLOR_DEFAULT;

  const showCaptions = !!clip.asset_metadata.subtitle;

  return {
    ...clip,
    asset_metadata: {
      ...clip.asset_metadata,
      layout: layout || 'GRID',
      fit: fit || 'FIT',
      hide_borders: !border,
      magicLayout: {
        ...clip.asset_metadata.magicLayout,
        textColor:
          (showCaptions
            ? clip.asset_metadata.magicLayout?.textColor
            : showSpeakerLabels
              ? rgbaToHex(name_card_background)
              : rgbaToHex(primary_text_color)) || TEXT_COLOR_DEFAULT,
        backgroundImage,
        backgroundColor,
        showSpeakerLabels
      },
      speaker_label_styles: migrateSpeakerLabelStyles({
        font_location: name_card_font_url || FONT_DEFAULT_VALUE.url,
        text_color: rgbaToHex(name_card_text_color),
        background_color: rgbaToHex(name_card_background),
        border_radius: name_card_border_radius
      })
    }
  };
};
